import { ComparablesFilterFields } from "../components/Filters/FiltersWithClear";

export const disabledZooplaFields = new Set<ComparablesFilterFields>([]);
export const disabledEPCFields = new Set<ComparablesFilterFields>(["bedrooms", "yearBuiltFrom", "yearBuiltTo"]);
